import { render, staticRenderFns } from "./SpacingMedium.vue?vue&type=template&id=4033afe8"
import script from "./SpacingMedium.vue?vue&type=script&lang=js"
export * from "./SpacingMedium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports